// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceTemplates_root__TSEYE {
  width: 100%;
  color: var(--color-font-10);
  height: calc(100vh - 133px);
  display: flex;
}

.InvoiceTemplates_template_list_container__ZvO3k {
  width: 29px;
  min-width: 290px;
  background-color: var(--color-bg-caselist);
  overflow-y: scroll;
  padding: 10px;
  overflow-x: hidden;
  height: calc(100vh - 140px);
  z-index: 100;
  align-items: center;
}

.InvoiceTemplates_add_template_container__7PVKw {
  display: flex;
  justify-content: center;
}
.InvoiceTemplates_template_container__5dyqx {
  background-color: var(--color-bg-content);
  width: 78%;
  min-width: fit-content;
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/InvoiceTemplates/InvoiceTemplates.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAGlB,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yCAAyC;EACzC,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".root {\n  width: 100%;\n  color: var(--color-font-10);\n  height: calc(100vh - 133px);\n  display: flex;\n}\n\n.template_list_container {\n  width: 29px;\n  min-width: 290px;\n  background-color: var(--color-bg-caselist);\n  overflow-y: scroll;\n  padding: 10px;\n  overflow-x: hidden;\n  height: -webkit-calc(100vh - 105px);\n  height: -moz-calc(100vh - 105px);\n  height: calc(100vh - 140px);\n  z-index: 100;\n  align-items: center;\n}\n\n.add_template_container {\n  display: flex;\n  justify-content: center;\n}\n.template_container {\n  background-color: var(--color-bg-content);\n  width: 78%;\n  min-width: fit-content;\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `InvoiceTemplates_root__TSEYE`,
	"template_list_container": `InvoiceTemplates_template_list_container__ZvO3k`,
	"add_template_container": `InvoiceTemplates_add_template_container__7PVKw`,
	"template_container": `InvoiceTemplates_template_container__5dyqx`
};
export default ___CSS_LOADER_EXPORT___;
